import { Link } from "react-router-dom";

function Section({ title, children }) {
    return (
        <div>
            <h3 className="font-display text-lg text-[#0B132B] font-medium mb-2 tracking-tight">
                {title}
            </h3>
            {children}
        </div>
    );
}

export function LegalPrivacy() {
    return (
        <section
            className="border-b border-slate-200"
            data-testid="legal-privacy"
        >
            <div className="mx-auto max-w-4xl px-6 md:px-12 lg:px-16 py-16 md:py-20">
                <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#0B132B] font-medium mb-10">
                    Politique de confidentialité
                </h2>

                <div className="space-y-8 text-base text-slate-600 leading-relaxed">
                    <Section title="Données collectées">
                        <p>
                            Le formulaire de contact recueille uniquement les
                            informations que vous transmettez volontairement
                            pour traiter votre demande&nbsp;: nom, adresse
                            email, mention de votre structure ou activité et
                            contenu de votre message. Ces données sont
                            transmises uniquement à Simon Marie.
                        </p>
                        <p className="mt-4">
                            Lorsqu'un site est consulté, l'hébergeur du site
                            peut techniquement recevoir certaines informations
                            de connexion (adresse IP approximative, horodatage,
                            type de navigateur). Ces données sont gérées par
                            l'hébergeur Netlify, conformément à sa propre
                            politique, et ne sont pas exploitées par
                            l'éditeur du site.
                        </p>
                    </Section>

                    <Section title="Finalité">
                        <p>
                            Les données sont utilisées exclusivement pour
                            traiter votre demande de prise de contact. Elles
                            ne font l'objet d'aucune prospection commerciale,
                            d'aucun transfert à un tiers et d'aucune diffusion
                            publique.
                        </p>
                    </Section>

                    <Section title="Conservation">
                        <p>
                            Les messages sont conservés le temps nécessaire au
                            traitement de l'échange, puis supprimés ou
                            archivés de manière sécurisée si la relation se
                            poursuit.
                        </p>
                    </Section>

                    <Section title="Vos droits">
                        <p>
                            Conformément au RGPD, vous disposez d'un droit
                            d'accès, de rectification, de limitation et de
                            suppression de vos données. Toute demande peut
                            être adressée via le formulaire de contact.
                        </p>
                    </Section>

                    <Section title="Suivi et cookies">
                        <p>
                            Le site n'utilise aucun cookie publicitaire,
                            aucun outil d'analytics tiers, aucun script de
                            mesure d'audience et aucun enregistrement de
                            session. Aucun suivi comportemental n'est mis en
                            œuvre. Aucune donnée n'est partagée avec des
                            services tiers à finalité marketing.
                        </p>
                    </Section>
                </div>

                <div className="mt-14">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-sm font-medium text-[#0B132B] border-b border-[#0B132B] pb-0.5 hover:gap-3 transition-all"
                        data-testid="legal-back-home"
                    >
                        ← Retour à l'accueil
                    </Link>
                </div>
            </div>
        </section>
    );
}
